import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import TrustBar from "../../components/feature/TrustBar";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../../components/feature/WhyChooseUs";
import ServiceAreas from "../../components/feature/ServiceAreas";
import Testimonials from "../../components/feature/Testimonials";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTA from "../../components/feature/FinalCTA";
import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection showTrustSignals />
      <TrustBar />
      <ServicesOverview showPostCTA />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
